var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorksheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 4.00004C3.5 3.17162 4.17155 2.50006 4.99996 2.50004L11.3905 2.49988C11.7554 2.49987 12.1078 2.63291 12.3817 2.87407L15.9912 6.05215C16.3147 6.33692 16.5 6.74703 16.5 7.17796V15.9999C16.5 16.8283 15.8284 17.4999 15 17.4999H5C4.17157 17.4999 3.5 16.8283 3.5 15.9999V4.00004ZM6.4 6.50013C5.90294 6.50013 5.5 6.90307 5.5 7.40013C5.5 7.89719 5.90294 8.30013 6.4 8.30013H13.6C14.0971 8.30013 14.5 7.89719 14.5 7.40013C14.5 6.90307 14.0971 6.50013 13.6 6.50013H6.4ZM5.5 10.9001C5.5 10.4031 5.90294 10.0001 6.4 10.0001H13.6C14.0971 10.0001 14.5 10.4031 14.5 10.9001C14.5 11.3972 14.0971 11.8001 13.6 11.8001H6.4C5.90294 11.8001 5.5 11.3972 5.5 10.9001ZM6.4 13.5001C5.90294 13.5001 5.5 13.9031 5.5 14.4001C5.5 14.8972 5.90294 15.3001 6.4 15.3001H13.6C14.0971 15.3001 14.5 14.8972 14.5 14.4001C14.5 13.9031 14.0971 13.5001 13.6 13.5001H6.4Z",
    fill: "#A140D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorksheet);
export default __webpack_public_path__ + "static/media/worksheet.9d4e630cdec14720d6fbe7d07de0fd83.svg";
export { ForwardRef as ReactComponent };